import { apiSlice } from './apiSlice';

/**
 * The signed-in trader's own record, behind Profile → My Profile.
 *
 *   GET /v3/user/profile/details/ → { id, full_name, first_name, last_name,
 *     username, email, email_verified, is_2fa_enabled, photo, contact_number,
 *     country_code, country, city, member_since, last_sign_in, date_of_birth,
 *     time_zone, language }
 *
 * `country_code` is the dial code as a number (1, 91) and `country` the ISO
 * short name, so the page maps both back to what its selects hold.
 *
 *   PATCH /v3/user/profile/details/ ← any subset of those fields, → the whole
 *                                     record as it now stands
 */
export const profileApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getProfileDetails: builder.query({
      query: () => '/v3/user/profile/details/',
      providesTags: ['Profile'],
    }),

    updateProfileDetails: builder.mutation({
      query: (body) => ({
        url: '/v3/user/profile/details/',
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['Profile'],
    }),

    /**
     * The daily loss alert email, on or off.
     *
     *   GET   /v2/user/settings/daily-loss-alert-email/ → { daily_loss_alert_email }
     *   PATCH /v2/user/settings/daily-loss-alert-email/ ← { daily_loss_alert_email }
     */
    getDailyLossAlertEmail: builder.query({
      query: () => '/v2/user/settings/daily-loss-alert-email/',
    }),

    updateDailyLossAlertEmail: builder.mutation({
      query: (enabled) => ({
        url: '/v2/user/settings/daily-loss-alert-email/',
        method: 'PATCH',
        body: { daily_loss_alert_email: enabled },
      }),
      // The switch moves at once; a refusal puts it back.
      async onQueryStarted(enabled, { dispatch, queryFulfilled }) {
        const patch = dispatch(
          profileApi.util.updateQueryData('getDailyLossAlertEmail', undefined, (draft) => {
            if (draft) draft.daily_loss_alert_email = enabled;
          }),
        );
        try {
          await queryFulfilled;
        } catch {
          patch.undo();
        }
      },
    }),
  }),
});

export const {
  useGetProfileDetailsQuery,
  useUpdateProfileDetailsMutation,
  useGetDailyLossAlertEmailQuery,
  useUpdateDailyLossAlertEmailMutation,
} = profileApi;
